import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ATRProbeLabApplications = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000 
  };

  const images = [
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrdLibrary%2F4.png?alt=media&token=30c1f671-8abb-4694-be0b-19e40f6e089b',
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrdLibrary%2F4.png?alt=media&token=30c1f671-8abb-4694-be0b-19e40f6e089b'
  ];

  return (
    <Layout>
      <div className="bread">
        <ul className="collapsed">
          <li><a href="/">Home</a></li>
          <li><a href="/RD-Instruments/optical-probes">Optical Probes</a></li>
        </ul>
      </div>
      <div className="container">
        <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
          <h1>ATR Probe for Lab Applications</h1>
        </div>
      </div>
      <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="portfolio-details-slider swiper">
                <Slider {...settings}>
                  {images.map((src, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="img" style={{ alignItems: 'center' }}>
                        <img src={src} alt="" className="responsive" />
                      </div>
                    </div>
                  ))}
                </Slider>
                <div className="swiper-pagination"></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                <h3 className='pageheading'>ATR Probe for Lab Applications</h3>
                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                 Evanescent absorption spectra without dead zone problems
Optimal ATR- crystal selection to match customer application. Cost effective solution for in-line reaction monitoring. New designed IR fiber ATR probes with PEEK shaft and perfect for use in small lab reactors and open vessels. Compatible to any type of FT-IR and other IR-spectrometers, photometers and sensors.


<br />
                  <a
                    href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                    style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                  >
                    More Info
                  </a>
                </p>
              </div>
              <div className="portfolio-description"></div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ATRProbeLabApplications